(() => {
  // One loader even if an editor section is rendered repeatedly.
  if (window.NSProductBadges) { window.NSProductBadges.init(); return; }
  const controllers = new Map();

  function stockState(variant, automatic, threshold) {
    if (!automatic || !variant) return '';
    if (variant.available === false) return 'Sold out';
    if (variant.available !== true || !variant.tracked || variant.backorder || variant.thresholdExceeded) return '';
    if (!Number.isInteger(threshold) || threshold < 1 || threshold > 100 ||
        !Number.isInteger(variant.quantity)) return '';
    return variant.quantity > 0 && variant.quantity <= threshold ? 'LOW STOCK' : '';
  }

  function fallbackSelection(inputId, variantCount, initialId) {
    // Only a single-variant product can safely use its initial variant without a picker.
    if (inputId !== undefined) return inputId ? { id: inputId } : null;
    return variantCount === 1 && initialId ? { id: initialId } : null;
  }

  function editorialState(variant, defaults) {
    const raw = String(variant?.badgeStyle ?? defaults.kind ?? '').trim();
    const key = raw.toLowerCase().replace(/[\s_-]+/g, '');
    const text = String(variant?.badgeText ?? defaults.text ?? '').trim();
    if (['none', 'off', 'false'].includes(key)) return null;
    if (['bestseller', 'bestselling'].includes(key)) return { kind: 'bestseller', text: text || 'BESTSELLER' };
    if (['trending', 'trend'].includes(key)) return { kind: 'trending', text: text || 'TRENDING' };
    const label = text || (key !== 'custom' ? raw : '');
    return label ? { kind: 'custom', text: label } : null;
  }

  function mount(host) {
    const productId = host.dataset.productId;
    const product = document.querySelector(`product-info[data-product-id="${productId}"]`);
    if (!product || controllers.has(host.dataset.sectionId)) return;
    const preview = document.querySelector(`.jdgm-preview-badge[data-id="${productId}"]`);
    const appBlock = preview?.closest('.shopify-block');
    if (!appBlock || appBlock.querySelector('.ns-product-signal-row')) return;
    let variants, defaults;
    try {
      variants = JSON.parse(host.querySelector('[data-variant-stock]').textContent);
      defaults = JSON.parse(host.querySelector('[data-badge-defaults]').textContent);
    }
    catch { return; }

    const section = host.closest('.shopify-section');
    const anchor = document.createComment('NS product badges original position');
    host.before(anchor);
    const originalParent = preview.parentNode;
    const reviewAnchor = document.createComment('Judge.me original position');
    preview.before(reviewAnchor);
    const row = document.createElement('div');
    row.className = 'ns-product-signal-row';
    preview.before(row);
    row.append(preview, host);
    if (section) section.hidden = true;
    const hot = host.querySelector('[data-hot]');
    const editorialGroup = host.querySelector('.ns-product-badges__editorial');
    const editorial = host.querySelector('[data-editorial]');
    const stock = host.querySelector('[data-stock]');
    const automatic = host.dataset.autoStock === 'true';
    const threshold = Number(host.dataset.threshold);
    const mobile = window.matchMedia('(max-width: 749px)');
    const gallery = product.querySelector('.product__media-wrapper');
    const galleryOverlay = gallery ? document.createElement('div') : null;
    if (galleryOverlay) {
      galleryOverlay.className = 'ns-product-gallery-stock';
      galleryOverlay.hidden = true;
      gallery.classList.add('ns-product-stock-gallery');
      product.classList.add('ns-product-compact-gallery');
      gallery.prepend(galleryOverlay);
    }
    function placeStock(hasEditorial, label) {
      const onGallery = !!(mobile.matches && hasEditorial && galleryOverlay && label);
      if (onGallery) {
        if (stock.parentNode !== galleryOverlay) galleryOverlay.append(stock);
      } else if (stock.parentNode !== host) editorialGroup.after(stock);
      if (galleryOverlay) galleryOverlay.hidden = !onGallery;
    }


    function selectedVariant() {
      const selected = product.querySelector('variant-selects [data-selected-variant]');
      if (selected) {
        try { return JSON.parse(selected.textContent); } catch { return null; }
      }
      // A picker with no known selection must never fall back to the first variant.
      if (product.querySelector('variant-selects')) return null;
      const input = product.querySelector('form[action*="/cart/add"] [name="id"]');
      return fallbackSelection(input ? input.value : undefined,
        Number(host.dataset.variantCount), host.dataset.initialVariant);
    }
    function refresh() {
      const selected = selectedVariant();
      const data = selected?.id ? variants[String(selected.id)] : null;
      const variant = data && { ...data, ...(typeof selected.available === 'boolean' ? { available: selected.available } : {}) };
      const label = stockState(variant, automatic, threshold);
      const manual = editorialState(data, defaults);
      editorial.hidden = !manual;
      if (manual) {
        editorial.className = 'ns-product-badges__badge ns-product-badges__badge--' + manual.kind;
        if (editorial.textContent !== manual.text) editorial.textContent = manual.text;
      }
      hot.hidden = !data?.hot;
      const hasEditorial = !!manual || !hot.hidden;
      editorialGroup.hidden = !hasEditorial;
      host.toggleAttribute('data-has-editorial', hasEditorial);
      if (stock.textContent !== label) stock.textContent = label;
      stock.dataset.state = label === 'Sold out' ? 'sold-out' : 'low-stock';
      stock.hidden = !label;
      placeStock(hasEditorial, label);
      host.hidden = !label && !hasEditorial;
    }
    const change = event => {
      if (event.target.matches('[name="id"]')) refresh();
    };
    product.addEventListener('change', change);
    mobile.addEventListener('change', refresh);
    // Only local picker replacement, not a document-wide observer or timer.
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target.parentElement?.closest('variant-selects') ||
          record.target.closest?.('variant-selects') ||
          [...record.addedNodes].some(node => node.nodeType === 1 &&
            (node.matches('variant-selects') || node.querySelector('variant-selects'))))) refresh();
    });
    observer.observe(product, { childList: true, subtree: true, characterData: true });
    refresh();
    controllers.set(host.dataset.sectionId, () => {
      observer.disconnect();
      product.removeEventListener('change', change);
      mobile.removeEventListener('change', refresh);
      editorialGroup.after(stock);
      galleryOverlay?.remove();
      gallery?.classList.remove('ns-product-stock-gallery');
      product.classList.remove('ns-product-compact-gallery');
      if (reviewAnchor.isConnected) reviewAnchor.after(preview);
      else originalParent.append(preview);
      reviewAnchor.remove();
      if (anchor.isConnected) anchor.after(host);
      else host.remove();
      anchor.remove();
      row.remove();
      if (section) section.hidden = false;
    });
  }
  function init() { document.querySelectorAll('[data-ns-product-badges]').forEach(mount); }
  window.NSProductBadges = { init };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    const id = event.detail?.sectionId;
    if (controllers.has(id)) { controllers.get(id)(); controllers.delete(id); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
